import { Error } from "@mui/icons-material";
import { Box, Theme, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBellSlash, IconDefinition } from "@elynx/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Stack, SxProps } from "@mui/system";
import { ISummaryUsageDTO } from "../../services/setpoint-administration-service/Models";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";


export type SetpointUsageItemProps = {
    name: string;
    item: ISummaryUsageDTO;
    alarmColor: string;
    acknowledgeColor: string;
    grouped: boolean;
    sx?: SxProps<Theme>;
    size?: 'small' | 'medium';
    //onAction: (action: RoleActionEnum, payload: RoleActionPayloadType) => void,
};

export function SetpointUsageItem({
    name,
    item,
    alarmColor,
    acknowledgeColor,
    grouped,
    sx,
    size,
    //onAction,
}: SetpointUsageItemProps) {

    const theme = useTheme();
    const { t } = useTranslation();

    function getIcon(): IconDefinition {
        return item.isDisabled ? faBellSlash : faBell;

    }

    function getIconColor(): string | undefined {

        return item.isDisabled ?
            theme.palette.grey[600] :
            item.isAcknowledged ?
            acknowledgeColor :
            item.inAlarm ?
            alarmColor :
            undefined;
    }


    return (
        <Box sx={{
            marginTop: .5,
            display: 'flex',
            flexDirection: 'column',
            ...sx
            }}>
            {!grouped && <Typography 
                variant={size === 'medium' ? 'body1' : 'body2'}
                sx={{
                    color: theme.palette.grey[600]
                }}>
                {name}
            </Typography>}
            <Stack direction='row'>

                <Box component='span' sx={{
                    marginTop: size === 'medium' ? theme.spacing(.2) : undefined
                }}>
                <FontAwesomeIcon 
                    icon={getIcon()} 
                    width={size === 'medium' ? 30 : undefined}
                    size={size === 'small' ? 'sm' : undefined} 
                    fontSize={size === 'medium' ? '1.5em' : undefined}
                    color={getIconColor()} />
                </Box>                    

                <Typography 
                    variant={size === 'medium' ? 'body1' : 'body2'}
                    sx={{
                        marginLeft: 1,
                        color: theme.palette.grey[600]
                    }}>
                   
                    {item.valueDate ?
                        grouped ?
                        <>
                            <Box component='span' sx={{
                                textDecoration: item.tagHidden ? 'line-through' : undefined,
                                fontStyle: item.tagDisabled ? 'italic' : undefined,
                                color: item.tagDisabled ? theme.palette.grey[500] : undefined
                            }}>
                                {item.tagName}
                            </Box>
                            <Box>
                                {`${t('setpointAdmin.tagValueUsageText', {value: item.valueText, ts: getTimeframeTimeDisplayText(TimeframeTypeEnum.None, item.valueDate)})}`}
                            </Box>
                        </> :
                        <>
                            <Box component='span' sx={{marginRight: theme.spacing(1)}}>
                                {item.tagObjectName}:
                            </Box>
                            <Box component='span' sx={{
                                textDecoration: item.tagHidden ? 'line-through' : undefined,
                                fontStyle: item.tagDisabled ? 'italic' : undefined,
                                color: item.tagDisabled ? theme.palette.grey[500] : undefined
                            }}>
                                {item.tagName}
                            </Box>
                            <Box component='span'>

                            {t('setpointAdmin.tagValueUsageText', {value: item.valueText, ts: getTimeframeTimeDisplayText(TimeframeTypeEnum.None, item.valueDate)})} 
                        </Box>
                        </> :

                        grouped ?

                        <Box component='span' sx={{
                            textDecoration: item.tagHidden ? 'line-through' : undefined,
                            fontStyle: item.tagDisabled ? 'italic' : undefined,
                            color: item.tagDisabled ? theme.palette.grey[500] : undefined
                        }}>
                            {item.tagName}
                        </Box>
                        :
                        <>
                            <Box component='span' sx={{marginRight: theme.spacing(1)}}>
                                {item.tagObjectName}:
                            </Box>
                            <Box component='span' sx={{
                                textDecoration: item.tagHidden ? 'line-through' : undefined,
                                fontStyle: item.tagDisabled ? 'italic' : undefined,
                                color: item.tagDisabled ? theme.palette.grey[500] : undefined
                            }}>
                                {item.tagName}
                            </Box>
                            {/* <Box component='span'>
                                {t('setpointAdmin.deviceTagUsageText', {name: item.tagObjectName, tag: item.tagName})}
                            </Box> */}
                        
                        </> 
                    }
                </Typography>

                {item.tagUomIsIncompatible &&
                    <Stack direction='row' sx={{ marginLeft: 1 }}>
                        <Error
                            fontSize="small"
                            sx={{
                                color: theme.palette.error.main
                            }} 
                        />
                        <Typography
                            variant={size === 'medium' ? 'body1' : 'body2'}
                            sx={{
                                marginLeft: 1,
                                color: theme.palette.error.main
                            }}>
                            {t('setpointAdmin.tagUomNotCompatible')}
                        </Typography>
                    </Stack>
                }
            </Stack>
        </Box>
    );
}
